import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiCheck, FiX } from "react-icons/fi";
import "../css/paysuccess.css";

const PaymentResult = () => {
  const { search } = useLocation();
  const state = new URLSearchParams(search).get("state");
  const isSuccess = state === "success";
  const isCancelled = state === "cancel";

  return (
    <main className="order-success">
      <div className="order-success__card">
        <div className="order-success__icon" aria-hidden="true">
          {isSuccess ? <FiCheck /> : <FiX />}
        </div>
        <span className="order-success__eyebrow">
          {isSuccess ? "Payment received" : "Payment not completed"}
        </span>
        <h1>
          {isSuccess
            ? "Thank you for your order."
            : isCancelled
              ? "Your payment was cancelled."
              : "We could not confirm this payment."}
        </h1>
        <p className="order-success__lead">
          {isSuccess
            ? "Your payment was completed successfully. A confirmation will be sent to the email used at checkout."
            : "No completed payment has been recorded. Your cart is still available if you would like to try again."}
        </p>

        <div className="order-success__actions">
          <Link
            className="order-success__primary"
            to={isSuccess ? "/shop" : "/checkout"}
          >
            {isSuccess ? "Continue shopping" : "Return to checkout"}
          </Link>
          <Link className="order-success__secondary" to="/">
            Return home
          </Link>
        </div>
      </div>
    </main>
  );
};

export default PaymentResult;
